function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "video_call-24px",
  d: "M79.66,30.64V11.476A5.492,5.492,0,0,0,74.184,6H8.476A5.492,5.492,0,0,0,3,11.476V66.232a5.492,5.492,0,0,0,5.476,5.476H74.184a5.492,5.492,0,0,0,5.476-5.476V47.067L92.2,59.606a5.492,5.492,0,0,0,9.363-3.888V21.934A5.492,5.492,0,0,0,92.2,18.046Zm-21.9,13.689H46.806V55.28a5.476,5.476,0,0,1-10.951,0V44.329H24.9a5.476,5.476,0,1,1,0-10.951H35.854V22.427a5.476,5.476,0,0,1,10.951,0V33.378H57.757a5.476,5.476,0,1,1,0,10.951Z",
  transform: "translate(-3 -6)"
});

function SvgSelectVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.563,
    height: 65.707,
    viewBox: "0 0 98.563 65.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectVideo);
export default __webpack_public_path__ + "static/media/select-video.58a3bad6.svg";
export { ForwardRef as ReactComponent };